import clsx from 'clsx';
import * as React from 'react';

import type { ButtonProps } from './types';

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      variant = 'primary',
      size = 'small',
      leftIcon: LeftIcon,
      rightIcon: RightIcon,
      label,
      className,
      disabled,
      children,
      ...props
    },
    ref,
  ) => {
    return (
      <button
        data-component="CoreUIButton"
        ref={ref}
        className={clsx(
          'ods-rounded-4 disabled:ods-cursor-not-allowed',
          `ods-btn-${size}`,
          `ods-btn-${variant}`,
          className,
        )}
        disabled={disabled}
        {...props}
      >
        {children || (
          <div
            className={`ods-flex ods-items-center ods-justify-center ods-gap-1 ods-btn-label-${size}`}
          >
            {LeftIcon && <LeftIcon className={`ods-btn-icon-${size}`} data-testid="left-icon" />}
            <span className="ods-flex">{label}</span>
            {RightIcon && <RightIcon className={`ods-btn-icon-${size}`} data-testid="right-icon" />}
          </div>
        )}
      </button>
    );
  },
);
